// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'move-up-solid';

export const Component = () => (
  <path d='M2.048 3.915S2 3.894 2 3.867v-1.82C2 2.022 2.021 2 2.048 2h20.498c.027 0 .048.021.048.048v1.82a.047.047 0 0 1-.048.047H2.048Zm14.415 8.693-3.181-3.156V21.81c0 .589-.38.968-.971.968-.613 0-1.019-.368-1.019-.968V9.454l-3.181 3.169c-.144.249-.416.347-.743.347-.591 0-.971-.379-.971-.968 0-.26.101-.495.287-.68l4.895-4.924.129-.093c.263-.132.434-.196.603-.196.15 0 .248.042.555.196l.13.093 4.895 4.925c.186.184.287.42.287.68 0 .588-.38.967-.971.967-.31 0-.58-.114-.745-.361v-.001Z' />
);

export const viewBox = '0 0 25 25';
